import { normalizePercentage } from '../../helpers/Helpers';

/**
 * Layout nuevo (desde 2026, cadena '1'): Cuentas nuevas por tipo + Rechazos / %.
 * Reemplaza a los bloques "Cuentas nuevas" (Total/Básico #/%) y "Rechazo inicial" (CN, CN CP, CN CP SF, Anterior, Actual).
 * Se alinea con las vistas: tiendas sin % retención ni % cancelación; asesores sin canceladas, % retención ni % cancelación.
 */

const unir = (worksheet, desde, hasta, valor, estilo) => {
	worksheet.mergeCells(`${desde}:${hasta}`);
	const celda = worksheet.getCell(desde);
	celda.value = valor;
	celda.style = estilo;
};

// combina una columna de la fila 2 a la 4 con su subtítulo
const subtitulo = (worksheet, letra, valor, estilo) => unir(worksheet, `${letra}2`, `${letra}4`, valor, estilo);

const ancho = (worksheet, anchos) => {
	Object.keys(anchos).forEach((letra) => {
		worksheet.getColumn(letra).width = anchos[letra];
	});
};

/* ---------------------------------- TIENDAS ---------------------------------- */

export const encabezadoTiendasNuevo = (worksheet, titleStyle, subtitleStyle) => {
	unir(worksheet, 'A1', 'A4', 'Rank', titleStyle);
	unir(worksheet, 'B1', 'B4', 'Número de tienda', titleStyle);
	unir(worksheet, 'C1', 'C4', 'Tienda', titleStyle);
	unir(worksheet, 'D1', 'D4', 'Zona', titleStyle);
	unir(worksheet, 'E1', 'K1', 'Reactivaciones', titleStyle);
	unir(worksheet, 'L1', 'R1', 'Migraciones', titleStyle);
	unir(worksheet, 'S1', 'W1', 'Cuentas nuevas', titleStyle);
	unir(worksheet, 'X1', 'Y1', 'Rechazo inicial', titleStyle);
	unir(worksheet, 'Z1', 'Z4', '¿Si hoy fuera cierre de mes, ganarías estrella?', titleStyle);
	unir(worksheet, 'AA1', 'AC1', 'IPPF', titleStyle);

	const reactivacionesYMigraciones = [
		['E', 'Meta Global (C + CS)'], ['F', 'Avance Global (C + CS)'], ['G', 'Avance Crédito'],
		['H', 'Meta CS'], ['I', 'Avance CS'], ['J', 'Faltan'], ['K', '% Avance'],
		['L', 'Meta Global (C + CS)'], ['M', 'Avance Global (C + CS)'], ['N', 'Avance Crédito'],
		['O', 'Meta CS'], ['P', 'Avance CS'], ['Q', 'Faltan'], ['R', '% Avance'],
	];
	reactivacionesYMigraciones.forEach(([letra, texto]) => subtitulo(worksheet, letra, texto, subtitleStyle));

	subtitulo(worksheet, 'S', 'Cuentas Nuevas Tradicional', subtitleStyle);
	subtitulo(worksheet, 'T', 'Cuentas Nuevas Credipocket', subtitleStyle);
	subtitulo(worksheet, 'U', 'Cuentas Nuevas Self Service', subtitleStyle);
	subtitulo(worksheet, 'V', 'Cuentas Nuevas Total', subtitleStyle);
	subtitulo(worksheet, 'W', 'Cuentas totales canceladas en el mismo mes', subtitleStyle);
	subtitulo(worksheet, 'X', 'Rechazos', subtitleStyle);
	subtitulo(worksheet, 'Y', '%', subtitleStyle);
	subtitulo(worksheet, 'AA', 'Meta', subtitleStyle);
	subtitulo(worksheet, 'AB', 'Al mes anterior', subtitleStyle);
	subtitulo(worksheet, 'AC', 'Faltante', subtitleStyle);
};

export const anchosTiendasNuevo = (worksheet) => {
	ancho(worksheet, {
		A: 10, B: 25, C: 35, D: 20, E: 20, F: 25, G: 15, H: 10, I: 15, J: 10, K: 10,
		L: 20, M: 25, N: 15, O: 10, P: 15, Q: 10, R: 10,
		S: 20, T: 20, U: 20, V: 20, W: 40, X: 20, Y: 20, Z: 60,
		AA: 20, AB: 20, AC: 20,
	});
};

export const filaTiendasNuevo = (row, report) => {
	row.getCell(1).value = report.rank;
	row.getCell(2).value = report.id;
	row.getCell(3).value = report.tienda;
	row.getCell(4).value = report.zona;
	row.getCell(5).value = report.metaReactivacion;
	row.getCell(6).value = report.avanceReactivacion;
	row.getCell(7).value = report.avanceReactivacionesAsesorCredito;
	row.getCell(8).value = report.metaReactivacionCs;
	row.getCell(9).value = report.avanceReactivacionesAsesorCss;
	row.getCell(10).value = report.faltanReactivaciones;
	row.getCell(11).value = normalizePercentage(report.porcentajeReactivacion);
	row.getCell(12).value = report.metaMigracion;
	row.getCell(13).value = report.avanceMigracion;
	row.getCell(14).value = report.avanceMigracionesAsesorCredito;
	row.getCell(15).value = report.metaMigracionCs;
	row.getCell(16).value = report.avanceMigracionesAsesorCss;
	row.getCell(17).value = report.faltanteMigraciones;
	row.getCell(18).value = normalizePercentage(report.porcentajeMigracion);
	// Cuentas nuevas
	row.getCell(19).value = report.cuentasNuevas?.cn.total; // Tradicional
	row.getCell(20).value = report.cuentasNuevas?.cncp.total; // Credipocket
	row.getCell(21).value = report.cuentasNuevas?.cncpsf.total; // Self Service
	row.getCell(22).value = report.cuentasNuevas?.total; // Total
	row.getCell(23).value = report.canceladas; // Cuentas totales canceladas en el mismo mes
	// Rechazo inicial
	row.getCell(24).value = report.totalCuentasRechazo; // Rechazos
	row.getCell(25).value = normalizePercentage(report.rechazoInicalActual); // %
	row.getCell(26).value = report.ganaEstrella;
	row.getCell(27).value = normalizePercentage(report.metaIppf);
	row.getCell(28).value = normalizePercentage(report.metaIppfAnterior);
	row.getCell(29).value = normalizePercentage(report.ippfFaltante);
};

/* --------------------------------- EMPLEADOS --------------------------------- */

export const encabezadoEmpleadosNuevo = (worksheet, titleStyle, subtitleStyle) => {
	unir(worksheet, 'A1', 'A4', 'Rank', titleStyle);
	unir(worksheet, 'B1', 'B4', '# Empleado', titleStyle);
	unir(worksheet, 'C1', 'C4', 'Asesor', titleStyle);
	unir(worksheet, 'D1', 'D4', 'Área', titleStyle);
	unir(worksheet, 'E1', 'E4', 'Zona', titleStyle);
	unir(worksheet, 'F1', 'F4', 'Numero Tienda', titleStyle);
	unir(worksheet, 'G1', 'G4', 'Nombre Tienda', titleStyle);
	unir(worksheet, 'H1', 'K1', 'Reactivaciones', titleStyle);
	unir(worksheet, 'L1', 'O1', 'Migraciones', titleStyle);
	unir(worksheet, 'P1', 'S1', 'Cuentas nuevas', titleStyle);
	unir(worksheet, 'T1', 'U1', 'Rechazo inicial', titleStyle);
	unir(worksheet, 'V1', 'W1', 'IPPF', titleStyle);

	[
		['H', 'Meta individual'], ['I', 'Acumulado'], ['J', 'Faltan'], ['K', '% Avance'],
		['L', 'Meta individual'], ['M', 'Acumulado'], ['N', 'Faltan'], ['O', '% Avance'],
	].forEach(([letra, texto]) => subtitulo(worksheet, letra, texto, subtitleStyle));

	subtitulo(worksheet, 'P', 'Cuentas Nuevas Tradicional', subtitleStyle);
	subtitulo(worksheet, 'Q', 'Cuentas Nuevas Credipocket', subtitleStyle);
	subtitulo(worksheet, 'R', 'Cuentas Nuevas Self Service', subtitleStyle);
	subtitulo(worksheet, 'S', 'Cuentas Nuevas Total', subtitleStyle);
	subtitulo(worksheet, 'T', 'Rechazos', subtitleStyle);
	subtitulo(worksheet, 'U', '%', subtitleStyle);
	subtitulo(worksheet, 'V', 'Meta Tienda', subtitleStyle);
	subtitulo(worksheet, 'W', 'IPPF por asesor al mes anterior', subtitleStyle);

	ancho(worksheet, {
		B: 15, C: 40, D: 10, E: 10, F: 20, G: 35,
		H: 15, I: 15, J: 10, L: 15, M: 15,
		P: 20, Q: 20, R: 20, S: 20, T: 20, U: 15, V: 15, W: 30,
	});
};

export const filaEmpleadosNuevo = (row, report) => {
	row.getCell(1).value = report.rank;
	row.getCell(2).value = report.numeroEmpleado;
	row.getCell(3).value = report.nombreEmpleado;
	row.getCell(4).value = report.area;
	row.getCell(5).value = report.zona;
	row.getCell(6).value = report.numeroTienda;
	row.getCell(7).value = report.nombreTienda;
	row.getCell(8).value = report.metaReactivacion;
	row.getCell(9).value = report.avanceReactivacion;
	row.getCell(10).value = report.faltanReactivacion;
	row.getCell(11).value = normalizePercentage(report.porcentajeReactivacion);
	row.getCell(12).value = report.metaMigracion;
	row.getCell(13).value = report.avanceMigracion;
	row.getCell(14).value = report.faltanMigracion;
	row.getCell(15).value = normalizePercentage(report.porcentajeMigracion);
	// Cuentas nuevas
	row.getCell(16).value = report.cuentasNuevas?.cn.total; // Tradicional
	row.getCell(17).value = report.cuentasNuevas?.cncp.total; // Credipocket
	row.getCell(18).value = report.cuentasNuevas?.cncpsf.total; // Self Service
	row.getCell(19).value = report.cuentasNuevas?.total; // Total
	// Rechazo inicial
	row.getCell(20).value = report.totalCuentasRechazo; // Rechazos
	row.getCell(21).value = normalizePercentage(report.rechazoActual); // %
	row.getCell(22).value = normalizePercentage(report.metaIppf);
	row.getCell(23).value = normalizePercentage(report.ippfAnterior);
};
